module.exports = __webpack_public_path__ + "static/media/right-validate.42f7f0ae.png";